import React from 'react';
import Swal from 'sweetalert2';


function AReceberGrid({ arrayReceber, onPagar, onDelete, onEstornar, onEdit, onReceber, userPermissions }) {

    const formatarData = (isoString) => {
        if (!isoString) return '-';
        const data = new Date(isoString);
        // Adiciona tratamento para datas inválidas
        if (isNaN(data.getTime())) return 'Data inválida';
        return new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric' }).format(data);
    };

    const formatarValor = (valor) => {
        return (Number(valor) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    // Função auxiliar para gerar classes CSS do status
    const getStatusClass = (status) => {
        if (status === 'Pago') {
            return 'badge-success';
        } else {
            return 'badge-warning';
        }
    };

    if (!arrayReceber || arrayReceber.length === 0) {
        return (
            <div className="financeiro-empty-state">
                <div className="financeiro-empty-icon">
                    <i className="fas fa-hand-holding-usd"></i>
                </div>
                <h5 className="text-muted">Nenhum lançamento encontrado</h5>
                <p className="text-muted small">
                    Não há contas a receber cadastradas ou que correspondam à sua pesquisa.
                </p>
            </div>
        );
    }

    return (
        <div className="financeiro-grid-container">
            <table className="table-custom">
                <thead>
                    <tr>
                        <th className="text-center" style={{ width: '120px' }}>Ações</th>
                        <th className="text-start col-status">Status</th>
                        <th className="text-center" style={{ width: '100px' }}>Num. Doc</th>
                        <th className="text-start" style={{ width: '350px', maxWidth: '350px' }}>Cliente/Empresa</th>
                        <th className="text-end" style={{ width: '120px' }}>Valor Total</th>
                        <th className="text-center" style={{ width: '110px' }}>Cadastro</th>
                        <th className="text-center" style={{ width: '110px' }}>Vencimento</th>
                        <th className="text-center" style={{ width: '110px' }}>Pagamento</th>
                        <th className="text-center" style={{ width: '80px' }}>Prazo</th>
                        <th className="text-start" style={{ width: 'auto', minWidth: '200px' }}>Descrição</th>
                        <th className="text-start">Usuário Cad.</th>
                        <th className="text-center" style={{ width: '110px' }}>Últ. Alt.</th>
                        <th className="text-start">Usuário Alt.</th>
                    </tr>
                </thead>
                <tbody>
                    {arrayReceber.map((item) => (
                        <tr key={item.id}>
                            <td className="text-center" data-label="Ações">
                                <div className="actions-cell">
                                    <button onClick={(e) => {
                                        if (userPermissions && userPermissions['editar_financeiro_a_receber'] === false) {
                                            e.preventDefault();
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Acesso Negado',
                                                text: 'Este usuário não possui permissão de edição. Por favor, contate o administrador.',
                                                confirmButtonColor: '#2185c6'
                                            });
                                            return;
                                        }
                                        onEdit(item.id);
                                    }} className="btn-action-sm btn-edit" title="Editar">
                                        <i className="fas fa-edit"></i>
                                    </button>
                                    {item.status === 'Em aberto' ? (
                                        <button onClick={(e) => {
                                            if (!userPermissions || !userPermissions['pagar_financeiro_a_receber']) {
                                                e.preventDefault();
                                                Swal.fire({
                                                    icon: 'error',
                                                    title: 'Acesso Negado',
                                                    text: 'Você não tem permissão para efetuar recebimentos.',
                                                    confirmButtonColor: '#2185c6'
                                                });
                                                return;
                                            }
                                            onReceber(item.id)
                                        }} className="btn-action-sm btn-pagar" title="Receber">
                                            <i className="fas fa-check"></i>
                                        </button>
                                    ) : (
                                        <button onClick={(e) => {
                                            if (!userPermissions || !userPermissions['estornar_financeiro_a_receber']) {
                                                e.preventDefault();
                                                Swal.fire({
                                                    icon: 'error',
                                                    title: 'Acesso Negado',
                                                    text: 'Você não tem permissão para estornar recebimentos.',
                                                    confirmButtonColor: '#2185c6'
                                                });
                                                return;
                                            }
                                            onEstornar(item.id)
                                        }} className="btn-action-sm btn-estornar" title="Estornar">
                                            <i className="fas fa-undo"></i>
                                        </button>
                                    )}
                                    <button onClick={() => onDelete(item.id)} className="btn-action-sm btn-delete" title="Excluir" disabled={item.status === 'Pago'}>
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                            <td className="text-start col-status" data-label="Status">
                                <span className={`financeiro-badge ${getStatusClass(item.status)}`}>
                                    {item.status}
                                </span>
                            </td>
                            <td className="text-center" data-label="Num. Doc">
                                {item.numero_doc || '—'}
                            </td>
                            <td data-label="Cliente/Empresa" style={{ minWidth: '350px', maxWidth: '350px', width: '350px', display: 'table-cell', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                <span className="fw-medium text-dark">{item.cliente_nome || item.empresa_nome || 'N/A'}</span>
                            </td>
                            <td className="text-end fw-bold" data-label="Valor Total">{formatarValor(item.valor_total)}</td>
                            <td className="text-center" data-label="Cadastro">{formatarData(item.data_cadastro)}</td>
                            <td className="text-center" data-label="Vencimento">{formatarData(item.data_vencimento)}</td>
                            <td className="text-center" data-label="Pagamento">{formatarData(item.data_pagamento)}</td>
                            <td className="text-center" data-label="Prazo">{item.prazo ? `${item.prazo} d` : '-'}</td>
                            <td data-label="Descrição" style={{ width: 'auto', minWidth: '200px' }}>{item.descricao}</td>
                            <td data-label="Usuário Cad.">{item.usuario_cadastro || '-'}</td>
                            <td className="text-center" data-label="Últ. Alt.">{formatarData(item.data_ultima_alteracao)}</td>
                            <td data-label="Usuário Alt.">{item.usuario_ultima_alteracao || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default AReceberGrid;